import { render } from "./record.vue?vue&type=template&id=343a7700&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=343a7700&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343a7700"],['__file',"src/views/alfmeier/quest/record.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "343a7700"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('343a7700', __exports__)) {
    console.log('reload')
    api.reload('343a7700', __exports__)
  }
  
  module.hot.accept("./record.vue?vue&type=template&id=343a7700&scoped=true", () => {
    console.log('re-render')
    api.rerender('343a7700', render)
  })

}


export default __exports__